import type { Core, Schema } from "../../..";
import type { Parser } from "../parser";

import {
	contentTypeSuffix as cts,
	interfaceSuffix as isf,
} from "../misc/constants";

export class PageDataPropsParser implements Parser {
	parse(schema: Record<string, Schema.PageContentType>, config: Core.Config) {
		const contentTypeSuffix = config.autotypes?.contentTypeSuffix || cts;
		const interfaceSuffix = config.autotypes?.interfaceSuffix || isf;
		const names = Object.keys(schema).map(
			(name) => `${name}${contentTypeSuffix}${interfaceSuffix}`,
		);

		return names.length
			? `export type Page${contentTypeSuffix}${interfaceSuffix} = ${names.join("|")}`
			: "";
	}
}
